export default __webpack_public_path__ + "static/media/weather-medium.63e35c73.jpg";